import React, { useEffect, useRef, useState } from 'react'
import { DropTargetMonitor, useDrop } from 'react-dnd'

import { styled } from '@mui/material'
import { values } from 'lodash'
import { MosaicDropTargetPosition } from './internalTypes'
import { MosaicDragItem, MosaicDragType } from './models/mosaicDragType'
import { RootDropTarget } from './RootDropTarget'

type RootDropTargetsProps = {
  //
}

export const RootDropTargets: React.FC<RootDropTargetsProps> = () => {
  const [{ isDragging }] = useDrop({
    accept: [MosaicDragType.WINDOW, MosaicDragType.WIDGET_BUTTON, MosaicDragType.TREE_ITEM],
    collect: (monitor: DropTargetMonitor<MosaicDragItem>) => ({
      isDragging: monitor.getItem() !== null && (
        monitor.getItemType() === MosaicDragType.WINDOW ||
        monitor.getItemType() === MosaicDragType.WIDGET_BUTTON ||
        monitor.getItemType() === MosaicDragType.TREE_ITEM
      ),
    }),
  })
  const delayedIsDragging = useDelayedTrue(isDragging, 0)
  
  return (
    <StyledContainer $isDragging={delayedIsDragging}>
      {values<MosaicDropTargetPosition>(MosaicDropTargetPosition).map((position) => {
        return (
          <RootDropTarget position={position} path={[]} key={position} />
        )
      })}
    </StyledContainer>
  )
}

const StyledContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isDragging',
}) <{ $isDragging: boolean }>`
  display: ${({ $isDragging }) => ($isDragging ? 'block' : 'none')};
  width: 100%;
  height: 100%;
`

const useDelayedTrue = (currentValue: boolean, delay: number) => {
  const delayedRef = useRef(currentValue)

  const [, setCounter] = useState(0)
  const setAndRender = (newValue: boolean) => {
    delayedRef.current = newValue
    setCounter((count) => count + 1)
  }

  if (!currentValue) {
    delayedRef.current = false
  }

  useEffect(() => {
    if (delayedRef.current === currentValue || !currentValue) {
      return
    }

    const timer = window.setTimeout(() => setAndRender(true), delay)

    return () => {
      window.clearTimeout(timer)
    }
  }, [currentValue])

  return delayedRef.current
}
